// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"910":"1207989c","2315":"1f5fe265"}[chunkId] + ".chunk.css";
};